import { clamp } from './clamp';

export function relocateTooltip(el, x, y, push = 20) {
  const { width, height } = el.getBoundingClientRect();

  const innerWidth = window.innerWidth;
  const innerHeight = window.innerHeight;

  const left = clamp(x - width / 2, push, innerWidth - width - push);
  const top =
    innerHeight > y + push * 2 + height ? y + push : y - height - push;

  el.style.left = `${left}px`;
  el.style.top = `${top}px`;
}
